import type { CSSProperties } from "react";

import { opaqueRgbToHex } from "~/hec/utils/color-contrast";

/**
 * The Core:Button "custom" variant's colors (COM-884) as the CSS variables the
 * variant's classes read (`link-render.tsx`), merged over any Builder style
 * attribute. A blank, translucent or malformed color is left out (fail closed),
 * so the site's primary color applies instead of no background at all. Other
 * variants get the style attribute unchanged.
 */
export const toCustomButtonStyle = (
  variant: string | undefined,
  buttonColor: string | undefined,
  buttonHoverColor: string | undefined,
  style: unknown,
): CSSProperties | undefined => {
  const base =
    style && typeof style === "object" ? (style as CSSProperties) : undefined;
  if (variant !== "custom") return base;
  const bg = opaqueRgbToHex(buttonColor);
  const hover = opaqueRgbToHex(buttonHoverColor);
  const vars: Record<string, string> = {};
  if (bg) vars["--hec-button-bg"] = bg;
  if (hover) vars["--hec-button-hover-bg"] = hover;
  return Object.keys(vars).length ? { ...base, ...vars } : base;
};
